import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'

export interface StudentDataDTO {
  educationalIdentifier?: string | null
  studentCardNumber?: string | null
  neptunCode?: string | null
  cusmanId?: string | null
}

export function useMyProfile() {
  return useQuery({
    queryKey: ['my-student-data'],
    queryFn: async () => {
      const { data } = await apiClient.get<StudentDataDTO>('/api/profile/my-student-data')

      return data
    },
  })
}
